import React from 'react'

interface Props {
  direction?: 'right' | 'down'
}

export const Caret = (props: Props) => (
  <svg
    width="9"
    height="8"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    style={{ marginLeft: '6px' }}
    aria-hidden="true"
    transform={props.direction === 'right' ? 'rotate(-90, 0, -1.5)' : undefined}
  >
    <path
      d="M1 1L4.5 4.5L8 1"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
